import UserService from "../../services/user-service";

function Authorise() {
    return (
        <UserService />
    );
}

export default Authorise;